<template>
	<div>
		<b-datepicker
			v-model="dates"
			:placeholder="placeholder"
			:date-formatter="dateFormatter"
			:disabled="!picker"
			:max-date="new Date()"
			:position="position"
			range
			@input="inputDate"
		>
		</b-datepicker>
	</div>
</template>

<script>
import { date_long, date_server } from "@lab/utils/format";

export default {
	name: "DateRangePicker",
	props: {
		start: {
			type: String,
			default: () => {
				var date = new Date();
				date.setDate(date.getDate() - 7);
				return date_server(date);
			}
		},
		end: {
			type: String,
			default: () => {
				var date = new Date();
				date.setDate(date.getDate());
				return date_server(date);
			}
		},
		picker: {
			type: Boolean,
			default: () => false
		},
		position: {
			type: String,
			default: () => "is-bottom-right",
			validator: (value) => {
				return [
					"is-top-right",
					"is-top-left",
					"is-bottom-left",
					"is-bottom-right"
				].includes(value);
			}
		}
	},
	data() {
		return {
			dateFormat: "d MMM yyyy",
			startDate: "",
			endDate: "",
			startUpdated: "",
			endUpdated: "",
			changed: false,
			dates: []
		};
	},
	computed: {
		placeholder() {
			return this.formatDates(this.start, this.end);
		}
	},
	watch: {
		picker(value) {
			if (value) {
				this.dates = [new Date(this.start), new Date(this.end)];
			} else {
				this.dates = [];
			}
		}
	},
	methods: {
		dateFormatter(date) {
			if (date) {
				return this.formatDates(date[0], date[1]);
			}
		},
		formatDates(dateOne, dateTwo) {
			let formattedDates = "";
			if (dateOne) {
				formattedDates = date_long(dateOne);
			}
			if (dateTwo) {
				formattedDates += " - " + date_long(dateTwo);
			}
			return formattedDates;
		},
		inputDate(value) {
			if (value.length) {
				this.startUpdated = date_server(value[0]);
				this.endUpdated = date_server(value[1]);
				this.applyDate();
			}
		},
		setStart(value) {
			this.startUpdated = value;
		},
		setEnd(value) {
			this.endUpdated = value;
		},
		applyDate() {
			this.$emit("apply", {
				value: this.startUpdated,
				position: "start"
			});
			this.$emit("apply", { value: this.endUpdated, position: "end" });
		},
		cancelDate() {
			if (this.changed) {
				this.startDate = this.start;
				this.endDate = this.end;
			}
		}
	}
};
</script>

<style lang="scss">
.datepicker {
	width: 230px;

	.dropdown {
		&.is-bottom-left .dropdown-menu {
			right: 0;
			left: auto;
		}
		&.is-top-left .dropdown-menu {
			top: auto;
			bottom: 100%;
			right: 0;
			left: auto;
		}
		&.is-top-right .dropdown-menu {
			top: auto;
			bottom: 100%;
		}
	}
}
</style>
